"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Question = function Question(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M12.5 19.4012C12.8596 19.4012 13.1511 19.1097 13.1511 18.7502C13.1511 18.3906 12.8596 18.0991 12.5 18.0991C12.1405 18.0991 11.849 18.3906 11.849 18.7502C11.849 19.1097 12.1405 19.4012 12.5 19.4012Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 5.72925C11.5334 5.73034 10.6067 6.1148 9.92323 6.79829C9.23974 7.48178 8.85527 8.40848 8.85419 9.37508C8.85419 9.51321 8.90906 9.64569 9.00674 9.74337C9.10441 9.84104 9.23689 9.89591 9.37502 9.89591C9.51315 9.89591 9.64563 9.84104 9.74331 9.74337C9.84098 9.64569 9.89585 9.51321 9.89585 9.37508C9.89585 8.86003 10.0486 8.35654 10.3347 7.92828C10.6209 7.50003 11.0276 7.16625 11.5034 6.96915C11.9793 6.77204 12.5029 6.72047 13.0081 6.82095C13.5132 6.92144 13.9772 7.16946 14.3414 7.53366C14.7056 7.89786 14.9537 8.36187 15.0541 8.86703C15.1546 9.37219 15.1031 9.8958 14.906 10.3717C14.7089 10.8475 14.3751 11.2542 13.9468 11.5404C13.5186 11.8265 13.0151 11.9792 12.5 11.9792C12.3619 11.9792 12.2294 12.0341 12.1317 12.1318C12.0341 12.2295 11.9792 12.3619 11.9792 12.5001V15.6251C11.9792 15.7632 12.0341 15.8957 12.1317 15.9934C12.2294 16.091 12.3619 16.1459 12.5 16.1459C12.6382 16.1459 12.7706 16.091 12.8683 15.9934C12.966 15.8957 13.0209 15.7632 13.0209 15.6251V12.9836C14.7853 12.73 16.1459 11.2086 16.1459 9.37508C16.1448 8.40848 15.7603 7.48178 15.0768 6.79829C14.3933 6.1148 13.4666 5.73034 12.5 5.72925Z",
    fill: props.foregroundColor
  }));
};

Question.defaultProps = {
  altText: "Question",
  foregroundColor: "#2D5AB4"
};
Question.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Question;
exports.default = _default;